import React from 'react';
import { useFiltersContext } from '../contexts/filters';
import { useSettingsContext } from '../contexts/settings';

interface IProps {
	children: React.ReactNode;
}

const SearchBar = ({ children }: IProps) => {
	const settings = useSettingsContext();

	return (
		<div className="pfa-search-bar" data-theme="blueberry">
			<div className="pfa-search-bar__wrapper">
				<h1 className="pfa-search-bar__title">{settings.searchTitle}</h1>
				<div className="pfa-search-bar__search">{children}</div>
			</div>
		</div>
	);
};

export default SearchBar;
